import { font_size_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.PhysicalCardAcknowledgements {
    .legal-text {
      font-size: ${font_size_md};
      line-height: 20px;
    }
  }
`
